import { createFileRoute } from '@tanstack/react-router';

import { CreateSupplierPage } from '@/features/suppliers/CreateSupplierPage';

/*
  Its own route rather than a mode on the record, because the register's Add supplier opens it and
  a half-made supplier has no id to be at. The path sits before $supplierId in the generated tree,
  so "new" is never read as an id.
*/
export const Route = createFileRoute('/_app/suppliers/new')({
    component: CreateSupplierPage,
});
